define('ItemBadges.ProductDetail', [
    'ItemBadges.Collection',
    'ItemBadges.View'
], function ItemBadgesProductDetail(
    ItemBadgesCollection,
    ItemBadgesView
) {
    'use strict';

    var pdp;
    var itemBadgesCollection;
    var itemBadgesProductDetail = {
        loadProductDetailItemBadges: function loadPDPItemBadges(application) {
            pdp = application.getComponent('PDP');

            itemBadgesProductDetail.loadProductDetailEvents();
            itemBadgesProductDetail.addProductDetailChildViews();
        },

        loadProductDetailEvents: function loadEventsPDP() {
            pdp.on('beforeShowContent', function beforeShowContent() {
                if (!itemBadgesCollection) {
                    itemBadgesCollection = new ItemBadgesCollection();
                }
            });

            pdp.on('afterShowContent', function afterShowContent() {
                if (itemBadgesCollection.length === 0) {
                    itemBadgesCollection.fetch();
                }
            });
        },

        addProductDetailChildViews: function addPDPChildViews() {
            pdp.addChildViews(
                pdp.PDP_FULL_VIEW, {
                    'Product.ImageGallery': {
                        'Itembadges.View': {
                            childViewIndex: 5,
                            childViewConstructor: function childViewConstructor() {
                                return new ItemBadgesView({
                                    view: 'pdp',
                                    items: pdp.getItemInfo(),
                                    collection: itemBadgesCollection
                                });
                            }
                        }
                    }
                }
            );

            pdp.addChildViews(
                pdp.PDP_QUICK_VIEW, {
                    'Product.ImageGallery': {
                        'Itembadges.View': {
                            childViewIndex: 5,
                            childViewConstructor: function childViewConstructor() {
                                return new ItemBadgesView({
                                    view: 'pdp',
                                    items: pdp.getItemInfo(),
                                    collection: itemBadgesCollection
                                });
                            }
                        }
                    }
                }
            );
        }
    };

    return itemBadgesProductDetail;
});
